module.exports = __webpack_public_path__ + "static/img/合作伙伴BG.3e8ff21f.png";